import { FlaskConical } from 'lucide-react';

/** Says, on the page itself, that what it shows is not the account's real data. */
export function SampleDataNote() {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-paper px-3 py-1.5 text-xs font-semibold text-muted shadow-[inset_0_0_0_1px_var(--line)]">
      <FlaskConical className="h-3.5 w-3.5" aria-hidden />
      Sample data, not yet connected to your account
    </span>
  );
}
